import React from "react";
import logger from "logger";
import { Route, Redirect } from "react-router-dom";
import Constants from "Utils/Constants";
import { useSelector } from "react-redux";

// handle the private routes
function PrivateRoute({ component: Component, ...rest }) {
  const token = useSelector(({ rootScope }) => {
    logger.log(rootScope);
    return rootScope.user && rootScope.user.access_token;
  });
  logger.log("Inprivate route", token);
  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: Constants.login, state: { from: props.location } }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
